import React, {Component} from 'react';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import OtpScreen from './enter-otp';
import RegistrationScreen from './registration-screen';
// import GoogleLogin from "react-google-login";
import {setCookie, CookieName} from '../../utils/cookieManager';
import Snackbar from '@material-ui/core/Snackbar';
import {Config} from '../../utils/Config';
import ReactGA from 'react-ga';

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenOtpScreen: false,
      isOpenRegScreen: false,
      mobileNumber: '',
      isNewUser: true,
      isSnackBarOpen: false,
    };
    this.initLogin = this.initLogin.bind(this);
    this.responseGoogle = this.responseGoogle.bind(this);
    this.openSnackBar = this.openSnackBar.bind(this);
  }

  componentDidMount() {}

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  componentDidUpdate() {
    this.ApiUrlTemplate = {
      LOGIN: `${Config.SECURED_API_HOST}/api/platform/login?mobileNumber=${this.state.mobileNumber}&newOtp=true`,
      REGISTTRAION: `${Config.SECURED_API_HOST}/api/platform/register?mobileNumber=${this.state.mobileNumber}&newOtp=true`,
    };
  }

  initLogin = (e) => {
    if (this.state.mobileNumber) {
      fetch(this.ApiUrlTemplate.LOGIN)
        .then((res) => res.json())
        .then((res) => {
          if (res !== null) {
            //existing user
            if (res === true) {
              this.setState({isOpenOtpScreen: true, isNewUser: false});
            } else if (res === false) {
              //new user
              fetch(this.ApiUrlTemplate.REGISTTRAION)
                .then((res) => res.json())
                .then((res) => {
                  this.setState({isOpenOtpScreen: true, isNewUser: true});
                })
                .catch((error) => {
                  this.openSnackBar(
                    'Something went wrong, Please with google login.'
                  );
                  console.log(error);
                });
            } else {
              this.openSnackBar(
                'Something went wrong, Please with google login.'
              );
            }
          } else {
            this.openSnackBar(
              'Something went wrong, Please with google login.'
            );
          }
        })
        .catch((error) => {
          this.openSnackBar('Something went wrong, Please with google login.');
          console.log(error);
        });
    } else {
      this.openSnackBar('Please enter mobile number');
    }
    ReactGA.event({
      category: 'login',
      action: 'login-get-otp-clicked',
    });
  };

  handleChange = (name) => (event) => {
    const val = event.target.value;
    if (name === 'mobileNumber') {
      if (val.length <= 10) {
        this.setState({[name]: val});
      }
    }
  };

  responseGoogle = (googleUser) => {
    // console.log(googleUser);
    var profile = googleUser.getBasicProfile();
    if (profile && profile.getId()) {
      setCookie(CookieName.USERNAME, profile.getName(), 60);
      setCookie(CookieName.USERIMG, profile.getImageUrl(), 60);
      setCookie(CookieName.USEREMAIL, profile.getEmail(), 60);
      setCookie(CookieName.LOGINTYPE, CookieName.GOOGLE, 60);
      this.postUserData(
        'google',
        profile.getName(),
        profile.getEmail(),
        profile.getImageUrl(),
        googleUser.getAuthResponse().id_token
      );
    } else {
      //login failed
    }
  };

  postUserData = (
    loginProvider,
    userName,
    email,
    picUrl,
    thirdPartyToken,
    gender,
    age
  ) => {
    if (!thirdPartyToken) {
      return;
    }

    const postData = {
      LoginProvider: loginProvider,
      Name: userName,
      Email: email,
      ProfileImage: picUrl,
      ThirdPartyToken: thirdPartyToken,
      Gender: gender,
      Age: age,
    };

    const url = `https://www.confirmtkt.com/Booking/secured-gateway.php?rtype=verify-token`;
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          setCookie(CookieName.USERTOKEN, res['confirmtkt-token'], 60);
          setCookie(CookieName.USERTEMPTOKEN, res.tempToken, 60);
          setCookie(CookieName.USERMOBILE, res['phone-number'], 60);
          const defaultPath = this.props.location.state
            ? this.props.location.state.defaultPath
            : '/rbooking-bus';
          this.props.history.replace(defaultPath);
        } else {
          //show error
        }
      })
      .catch((error) => {
        this.openSnackBar('Something went wrong, Please try again later.');
        console.log(error);
      });
  };

  render() {
    const loginContainerStyle = {
      padding: '60px 14px',
    };

    const inputbxStyle = {
      width: '100%',
    };

    const btnOtpStyle = {
      padding: '14px 16px',
    };

    const infoMsg = {
      fontSize: '1.1rem',
      color: '#aaa',
      margin: '1rem 0',
    };

    const title = (
      <div className="title-img-center">
        <img
          src="https://www.confirmtkt.com/img/horizontal.png"
          alt="confirmtkt_logo"
          height="40"
        />
        <br />
        <div id="">LOG IN/SIGN UP</div>
      </div>
    );

    const otpFlow = (
      <div className="mobile-number-input">
        <TextField
          label="Enter your Mobile Number"
          id="mobile-number"
          type="number"
          autoFocus={true}
          value={this.state.mobileNumber ? this.state.mobileNumber : ''}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+91</InputAdornment>
            ),
          }}
          style={inputbxStyle}
          onChange={this.handleChange('mobileNumber')}
        />
        <br />
        <br />
        <Button
          variant="contained"
          className="ctkt-btn-success zero-border-radius"
          style={btnOtpStyle}
          onClick={this.initLogin}
        >
          GENERATE OTP (One Time Password)
        </Button>
      </div>
    );

    // const googleFlow = (
    //   <GoogleLogin
    //     // clientId="240202165398-d4jlv5trkoleeqaoim6u6eo8e0g5fjdb.apps.googleusercontent.com"
    //     clientId="658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"
    //     buttonText="Login With Google"
    //     onSuccess={this.responseGoogle}
    //     onFailure={this.responseGoogle}
    //   />
    // );

    let defaultContent = (
      <div>
        {title}
        <div style={infoMsg}>
          Your tickets will be sent to the below Mobile number / Email
        </div>
        {otpFlow}
        <br />
        {/* <div>
          OR
          <br />
          Connect using
        </div>
        <br />
        {googleFlow} */}
      </div>
    );

    return (
      <div className="account-login">
        <Fab
          className="close-btn"
          color="secondary"
          aria-label="Add"
          onClick={() => this.props.history.goBack()}
        >
          <i className="material-icons">clear</i>
        </Fab>
        <div className="text-align-center" style={loginContainerStyle}>
          {this.state.isOpenOtpScreen ? (
            <OtpScreen
              mobileNumber={this.state.mobileNumber}
              isNewUser={this.state.isNewUser}
              history={this.props.history}
              defaultPath={
                this.props.location.state
                  ? this.props.location.state.defaultPath
                  : '/rbooking-bus'
              }
            />
          ) : this.state.isOpenRegScreen ? (
            <RegistrationScreen mobileNumber={this.state.mobileNumber} />
          ) : (
            defaultContent
          )}
        </div>

        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={10000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchQuery: state.searchReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
